export const CREATE_CARRIER = 'CREATE_CARRIER';
export const EDIT_CARRIER = 'EDIT_CARRIER';
export const DELETE_CARRIER = 'DELETE_CARRIER';
export const LIST_CARRIERS = 'LIST_CARRIERS';